var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"y-icon",style:(("background: " + _vm.color + "1a;width: " + (_vm.size*2) + "px;"))},[_c('i',{class:_vm.icon,style:(("color: " + _vm.color + ";font-size: " + _vm.size + "px;"))})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2881fa11","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YUI/YIcon/index.vue
// module id = null
// module chunks = 